module.exports = __webpack_public_path__ + "assets/GTAmerica-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Regular.ttf
// module id = 1015
// module chunks = 19